import React from 'react';
import WorkspaceIcon from '../../../assets/images/svg-icons-material-io/workspaces_FILL0_wght400_GRAD0_opsz48.svg';
import MailboxIcon from '../../../assets/images/svg-icons-material-io/local_post_office_FILL0_wght400_GRAD0_opsz48.svg';
import MailFwdIcon from '../../../assets/images/svg-icons-material-io/forward_to_inbox_FILL0_wght400_GRAD0_opsz48.svg';
import { Link } from 'react-router-dom';

const SubMenu = () => (
    <div className="SubMenu">
        {/*Sub menus for User Reports*/}

        <section
            id="btnUserReport"
            className="dashboard-subcontainer collapse"
            aria-label="User Reports submenu"
            >
            {/*User Activity Reports Box*/}
            <Link
                to={'/user-activity'}
                className="btn btn-primary dash-box box-user-activity animate slide delay-1"
                aria-label="User Activity Reports"
            >
                <div className="box-icon" aria-hidden="true">
                    <img src={WorkspaceIcon} className="filter-white" alt="" />
                </div>
                <div className="box-bottom" aria-hidden="true">
                    <div className="title">User Activity</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link>
            {/*Delete Activity Reports Box*/}
            <Link
                to={'/delete-user-activity'}
                className="btn btn-primary dash-box box-delect-activity animate slide delay-2"
                aria-label="Delete Activity Reports"
            >
                <div className="box-icon" aria-hidden="true">
                    <i className="bi bi-trash"></i>
                </div>
                <div className="box-bottom" aria-hidden="true">
                    <div className="title">Delete Activity</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link>
            {/*Mailbox Sizes Reports Box*/}
            <Link
                to={'/mailbox-size'}
                className="btn btn-primary dash-box box-mailbox animate slide delay-3"
                aria-label="Mailbox Sizes Reports"
            >
                <div className="box-icon" aria-hidden="true">
                    <img src={MailboxIcon} className="filter-white" alt="" />
                </div>
                <div className="box-bottom" aria-hidden="true">
                    <div className="title">Mailbox Sizes</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link >
            {/*User Status Reports Box*/}
            <Link
                to={'/user-status'}
                className="btn btn-primary dash-box box-userstatus animate slide delay-4"
                aria-label="User Status Reports"
            >
                <div className="box-icon" aria-hidden="true">
                    <i className="bi bi-clipboard2-data" alt=""></i>
                </div>
                <div className="box-bottom" aria-hidden="true">
                    <div className="title">User Status</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link >
            {/*Message Forwarding Reports Box*/}
            <Link
                to={'/message-forwarding'}
                className="btn btn-primary dash-box box-msgfwd animate slide delay-5"
                aria-label="Message Forwarding Reports"
            >
                <div className="box-icon" aria-hidden="true">
                    <img src={MailFwdIcon} className="filter-white" alt="" />
                </div>
                <div className="box-bottom" aria-hidden="true">
                    <div className="title">Message Forwarding</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link>
        </section >
    </div>
);

export default SubMenu;
